/*
import './App.css';
import Home from './pages/Home.jsx'
import ComingSoon from './components/learningComp/learn.jsx'
import { useState } from 'react';

function App() {
  const[showComingSoon, setComingSoon] = useState(false);

  {showComingSoon ? <ComingSoon /> : <Home />}

  return (
    <>
      <Home />
    </>
  );
}
export default App;
*/

import './App.css';
import Home from './pages/Home.jsx';

function App() {

  return (
    <>
      <Home />
    </>
  );
}

export default App;